export default __webpack_public_path__ + "static/media/tool-icon-shirt-orange-16.f770dd7a.svg";